import { SectionTypes } from '@fiverr-private/ai_brief';
import { MetadataEditComponent, MetadataViewComponent } from '../../../components/Sections/Metadata/MetadataSection';
import type { EnrichedMetadataQuestionType, SeededSection } from '../types';

export const mapMetadataQuestionToSeeded = (question: EnrichedMetadataQuestionType): SeededSection => {
    const isSingle = question.selection_type === 'single_select';
    const selectedAnswers = isSingle ? [question.answers[0]?.slug] : question.answers.slice(0, 2).map((a) => a.slug);

    return {
        id: `metadata_${question.metadata_type}`,
        title: question.display_name,
        type: SectionTypes.metadata,
        included: true,
        mandatory: question.display_priority === 1,
        readonly: false,
        content: selectedAnswers,
        metadata: {
            selectedAnswers,
            allAnswers: question.answers,
            question: {
                ...question,
                answers_limit: question.selection_type === 'multi_select' ? Math.max(question.answers_limit, 10) : 1,
            },
        },
        EditComponent: MetadataEditComponent,
        ViewComponent: MetadataViewComponent,
        focused: false,
        hideActions: false,
    };
};
